import { RouteConfig } from 'src/routing/types'

const ROUTE: RouteConfig = {
  name: 'contact',
  path: () => '/contact',
}

export default ROUTE
